























































































































































import { Component, Vue } from "vue-property-decorator";
import UsersApi from "@/services/UsersApi";
import AdminsApi from "@/services/AdminsApi";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class PreRegisterForm extends Vue {
  private form = {
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
  };

  // 利用規約/プライバシーポリシー同意チェックボックス オフ
  private checkbox = false;

  // メールが届かない場合の画面遷移
  private resendLink = "UPreRegisterResend";

  // エラーメッセージ表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // アカウントの仮登録
  private mounted() {
    // routeが管理者仮登録の場合
    if (this.$route.name === "MPreRegister") {
      // チェックボックス オン
      this.checkbox = true;
      // リンクを踏んだときにMPreRegisterResendに飛ぶ
      this.resendLink = "MPreRegisterResend";
    }
  }

  // チェックボックスのオンオフ切り替え
  private changeCheckbox() {
    this.$emit("changeCfm", this.checkbox);
  }

  // 送信が押されたとき
  private async submit() {
    try {
      if (this.$route.name === "UPreRegister") {
        // userPreRegisterまたはadminPreRegisterを実行
        await this.userPreRegister();
      } else {
        await this.adminPreRegister();
      }
    } catch (err) {
      if (err instanceof Error) {
        TooltipModule.commitIsShow(true);
        setTimeout(() => {
          TooltipModule.commitIsShow(false);
        }, 5000);
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // ユーザーログイン時で送信が押されたとき
  private async userPreRegister() {
    const UsersRes = await UsersApi.instance.createPreUser(this.form);
    if (!UsersRes?.data?.data?.user) {
      return;
    }
    // UPreRegisterCompに進む
    this.$router.push({ name: "UPreRegisterComp" });
  }

  // 管理者ログイン時で送信が押されたとき
  private async adminPreRegister() {
    const AdminsRes = await AdminsApi.instance.createPreAdmin(this.form);
    if (!AdminsRes?.data?.data?.admin) {
      return;
    }
    // MPreRegisterCompに進む
    this.$router.push({ name: "MPreRegisterComp" });
  }
}
